import dayjs from 'dayjs'

import type {
  LandingHeadline,
  LandingHero
} from '@VelocitySquared/sunny16-content-dataobjects-cady/booking'

export const bookingOpenDate = new Date('2026-05-01T12:00:00-04:00')

export const hero: LandingHero = {
  internalName: 'Landing Hero: Video Background',
  videoUrl:
    'https://store.cady.com/CadyStudios/media/SessionScheduling/2023/Web-Banner-1920x1080-3000kbps.mp4?ext=.mp4',
  posterImage: { assetId: '', alt: '', url: 'src/assets/webp/session-listing-hero-img.webp' },
  bookingOpenLabel: `Booking Opens ${dayjs(bookingOpenDate).format('MMMM DD, YYYY')}`,
  countdownLabel: '',
  reminderCtaLabel: 'Get a Reminder',
  addToCalendarCtaLabel: 'Add to Calendar',
  // TODO fill in the actual URL when available
  dataCollectionPageUrl: '#',
  calendarEventSummary: 'CADY Senior Portrait Booking Opens',
  calendarEventDescription: 'Book your senior portrait session at cady.com'
}

export const headline: LandingHeadline = {
  internalName: 'Landing Hero: Welcome Headline',
  heading: 'Welcome Class of 2027!',
  ctaLabel: 'Book Now',
  ctaSecondaryLabel: '',
  subtitle:
    "We're CADY, your school's exclusive photographer.\n\nWe're here to help make booking your senior portrait a seamless process."
}
